import { Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { ApplicationCard } from './ApplicationCard';
import { truefileServerApi } from 'api/truefilesServerApi';
import { IApplicationModel } from 'api/types/trueFileServerTypes';
import { useApiQuery } from 'hooks/useApiQuery';

export function ApplicationList(): JSX.Element {
  const navigate = useNavigate();

  const { apiResult } = useApiQuery({
    queryKey: ['application-query'],
    queryFn: () => truefileServerApi.GET('/api/applications'),
  });

  const applications: IApplicationModel[] = apiResult?.data ?? [];

  if (!applications.length) {
    return <Text color='gray.600'>Nothing to show.</Text>;
  }

  return (
    <>
      {applications.map((app) => (
        <ApplicationCard
          key={app.id}
          app={app}
          onClick={() => navigate(`/application/${app.id}/applicant/${app.applicants?.[0]!.id}`)}
        />
      ))}
    </>
  );
}
